import React, { FC, useEffect } from 'react';
import { useOrdersState } from '../../context/orders';
import { useAccordionState } from '@src/shared/context/accordion';
import { useGoogleMap } from '@react-google-maps/api';

interface IGoogleMapWrapperProps {
  children: React.ReactNode;
  mapCenter: {
    lat: number;
    lng: number;
  };
}

export const GoogleMapWrapper: FC<IGoogleMapWrapperProps> = ({
  children,
  mapCenter,
}) => {
  const map = useGoogleMap();
  const { ordersById } = useOrdersState();
  const { hoveredOrderReference } = useAccordionState();

  useEffect(() => {
    if (map) {
      if (map?.getDiv().clientWidth < 1456) {
        map.panTo({
          lat:
            ordersById[hoveredOrderReference]?.location?.latitude ||
            mapCenter.lat,
          lng:
            ordersById[hoveredOrderReference]?.location?.longitude ||
            mapCenter.lng,
        });
      }
      if (map?.getDiv().clientWidth > 1456 && map?.getZoom() < 16) {
        map.panTo({
          lat:
            ordersById[hoveredOrderReference]?.location?.latitude ||
            mapCenter.lat,
          lng:
            ordersById[hoveredOrderReference]?.location?.longitude ||
            mapCenter.lng,
        });
      }
    }
  }, [hoveredOrderReference]);
  return <>{children}</>;
};

export default GoogleMapWrapper;
